export const PHOTO_SIZES = {
  ORIGINAL: 'original',
  XX_LARGE: 'xx-large',
  X_LARGE: 'x-large',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small'
};

export const GALLERY_VALID_COMBINATIONS = [
  ['vertical', 'vertical', 'vertical'],
  ['vertical', 'horizontal', 'horizontal'],
  ['horizontal', 'horizontal', 'vertical'],
  ['vertical', 'vertical'],
  ['horizontal', 'horizontal'],
  ['horizontal', 'vertical'],
  ['vertical', 'horizontal'],
  ['horizontal'],
  ['vertical']
];
